// extracted by mini-css-extract-plugin
export default {"tupacGrid":"xn-z","tupacHeader":"yn-z","tupacHeader2":"zn-z","tupacMenu":"An-z","tupacMenu2":"Bn-z","tupacMain":"Cn-z","tupacMain2":"Dn-z"};